import React, { useContext } from "react";
export var LandscapeDisplayContext = React.createContext({
    width: typeof window !== "undefined" && window.innerWidth
        ? window.innerWidth
        : 0,
    height: typeof window !== "undefined" && window.innerHeight
        ? window.innerHeight
        : 0,
    inRotate: false,
});
export var useLandscapeDisplayInfo = function () {
    return useContext(LandscapeDisplayContext);
};
